module.exports = __webpack_public_path__ + "img/feature_c01.179f1827.svg";